import { FC, ReactNode } from "react";
import { Box, Button, CardActions, Divider } from "@mui/material";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

interface FormActionsProps {
  onVoltar: () => void;
  // No modo visualizar o botão Salvar não é exibido
  visualizar?: boolean;
  salvarDisabled?: boolean;
  labelVoltar?: string;
  labelSalvar?: string;
  iconeSalvar?: ReactNode;
  // "card" para o rodapé do formulário; "modal" para usar dentro do Modal.Footer
  variante?: "card" | "modal";
}

// Botões Voltar/Salvar dos formulários (mesmo padrão do XC WMS)
const FormActions: FC<FormActionsProps> = ({
  onVoltar,
  visualizar = false,
  salvarDisabled = false,
  labelVoltar = "Voltar",
  labelSalvar = "Salvar",
  iconeSalvar = <SaveOutlinedIcon />,
  variante = "card",
}) => {
  const botoes = (
    <>
      <Button
        variant="contained"
        color="warning"
        size="small"
        startIcon={<ArrowBackIosOutlinedIcon />}
        onClick={onVoltar}
      >
        {labelVoltar}
      </Button>
      {!visualizar && (
        <Button
          variant="contained"
          color="success"
          size="small"
          startIcon={iconeSalvar}
          type="submit"
          disabled={salvarDisabled}
        >
          {labelSalvar}
        </Button>
      )}
    </>
  );

  if (variante === "modal") {
    return <Box sx={{ display: "flex", gap: 1 }}>{botoes}</Box>;
  }

  return (
    <>
      <Divider />
      <CardActions sx={{ marginLeft: 1 }}>{botoes}</CardActions>
    </>
  );
};

export default FormActions;
